import { css } from "@emotion/react";
import styled from "@emotion/styled";
import type { pageColourOptions } from "./defaults";

const StyledColourOption = styled("button")(({ theme }) => ({
  width: "32px",
  height: "32px",
  margin: "4px 4px 0",
  boxShadow: `0 1px 4px 0 rgba(9, 9, 11, 0.08),
    inset 3px 3px 12px -12px #fff,
    inset -2px -2px 12px -12px ${theme.colours.uIGrey.dark._50},
    inset 0 0 0 0.5px #fff`,
  borderRadius: "50%",
}));

type ColourOptionProps = {
  updateColour: (colour: string | undefined) => void;
  colourBackground: string;
  colourLabel?: keyof typeof pageColourOptions;
};

export const ColourOption = ({
  colourLabel,
  updateColour,
  colourBackground,
}: ColourOptionProps) => {
  return (
    <StyledColourOption
      onClick={() => {
        updateColour(colourLabel);
      }}
      css={({ colours }) => css`
        background-color: ${colourBackground};
        border: ${!colourLabel
          ? `1px solid ${colours.uIGrey.dark._20}`
          : "none"};
      `}
      title={colourLabel || "default"}
    />
  );
};
